module.exports = __webpack_public_path__ + "img/tasks-reviews-icon.a59472fc.svg";